import React, { useEffect, useState } from 'react';
import styles from './StaffingLevelsDashboard.module.scss';

import Separator from 'components/Separator/Separator';
import { FilterButton, FilterChips, FilterWrapper } from 'components/FilterComponentsV2';

import DashboardWrapper from '../DashboardWrapper';
import SectionHeader from '../SectionHeader';

import FilterModal from './Filter';
import StaffingLevelsAvailability from './StaffingLevelsAvailability';

import {
  useTeamMemberDashboardActions,
  useTeamMemberDashboardSelector
} from 'hooks/TeamMemberDashboard';

export default function StaffingLevelsDashboard() {
  const [open, setOpen] = useState(false);
  const [filterData, setFilterData] = useState({});

  const { levelsDashboard, tabConfig } = useTeamMemberDashboardSelector();
  const { clearTabStateAction } = useTeamMemberDashboardActions();

  useEffect(() => {
    return () => {
      clearTabStateAction({ stateName: 'levelsDashboard' });
    };
  }, []);

  const handleFilterButtonClick = (sectionId) => {
    const filterData = tabConfig?.items?.find(({ id }) => id === sectionId) || {};

    if (!('id' in filterData)) return;

    setFilterData(filterData);
    setOpen(true);
  };

  return (
    <DashboardWrapper>
      <FilterModal open={open} setOpen={setOpen} filter={filterData} />
      {!!levelsDashboard?.length && (
        <div className={styles.statistics}>
          {levelsDashboard.map((sectionData, index) => (
            <div key={sectionData.id} className={styles.statistics__dashboard}>
              <SectionHeader title={sectionData.name || ''} />

              <FilterWrapper>
                <FilterButton
                  onClick={() => handleFilterButtonClick(sectionData.id)}
                  isActive={!!sectionData?.department?.id}
                />
                {!!sectionData?.department?.id && (
                  <FilterChips
                    chips={[{ chipId: 100, label: sectionData?.department?.name || '' }]}
                  />
                )}
              </FilterWrapper>

              <StaffingLevelsAvailability data={sectionData} />

              {levelsDashboard.length > 1 && index !== levelsDashboard.length - 1 && <Separator />}
            </div>
          ))}
        </div>
      )}
    </DashboardWrapper>
  );
}
